import React from "react";
import { TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { observer } from "mobx-react";
import { SyncStatus } from "./../../Resources/Constants";
import Lottie from "lottie-react";
import LoadingBoldWhite from "../../assets/LoadingBoldWhite.json";
import LoadingBold from "../../assets/LoadingBold.json";
import Colors from "../../Resources/Color";
import NetworkManager from "../Classes/NetworkManager";
import { useTranslation } from "react-i18next";

const SyncStatusIndicator = observer(({ syncStatusManager, white = false }) => {
  const syncStatus = syncStatusManager.syncStatus;
  const networkManager = NetworkManager.getInstance();
  const { t } = useTranslation();

  const handleUpload = async () => {
    if (!networkManager.isOffline) {
      await syncStatusManager.resolveErrors();
      console.log("handleUpload pressed");
    }
  };

  const SyncStatusIndicatorItem = observer(() => {
    if (networkManager.isOffline) {
      return <Ionicons name="cloud-offline-outline" size={20} color="gray" />;
    }

    switch (syncStatus) {
      case SyncStatus.WAITING:
        return (
          <Lottie
            animationData={white ? LoadingBoldWhite : LoadingBold}
            loop
            style={{ maxWidth: 18 }}
          />
        );

      case SyncStatus.SYNCED:
        return (
          <Ionicons
            name="cloud-done-outline"
            size={20}
            color={white ? Colors.whiteColor : Colors.blackColor}
          />
        );

      case SyncStatus.ERROR:
        return <Ionicons name="alert-circle-outline" size={20} color="red" />;

      default:
        return (
          <Ionicons name="cloud-outline" size={20} color={Colors.blackColor} />
        );
    }
  });

  return (
    <TouchableOpacity onPress={() => handleUpload()}>
      <SyncStatusIndicatorItem />
    </TouchableOpacity>
  );
});

export default SyncStatusIndicator;
